import React from 'react';
import Image from 'next/image';
interface PhoneDoctorInfoProps {
  doctorImage: string;
}
export const PhoneDoctorInfo: React.FC<PhoneDoctorInfoProps> = ({
  doctorImage
}) => {
  return <div className="flex flex-col items-center pb-3" data-sentry-component="PhoneDoctorInfo" data-sentry-source-file="PhoneDoctorInfo.tsx">
      <Image src={doctorImage} alt={doctorImage} className="size-24 rounded-full bg-white object-cover" width={96} height={96} data-sentry-element="Image" data-sentry-source-file="PhoneDoctorInfo.tsx" />
    </div>;
};